<template>
  <div v-resize="onResize">
    <div v-if="status.loading_giftcode" class="skeleton">
      <div class="giftcode-news__title">
        <img
          class="giftcode-news__icon"
          src="../assets/icons/giftcard.svg"
          alt=""
          srcset=""
        />
        Giftcode dành cho bạn
      </div>
      <div>
        <v-row>
          <v-col cols="12" md="6" v-for="(i, index) in 6" :key="index">
            <div>
              <v-skeleton-loader tile type="list-item-avatar-three-line">
              </v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
        <v-skeleton-loader tile type="list-item"> </v-skeleton-loader>
      </div>
    </div>
    <div v-else>
      <div class="giftcode-news__title" @click="show = !show">
        <img
          class="giftcode-news__icon"
          src="../assets/icons/giftcard.svg"
          alt=""
          srcset=""
        />
        Giftcode dành cho bạn
        <v-btn class="giftcode-news__button" icon >
          <v-icon color="primary">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </div>
      <div v-if="giftcodes.length !== 0">
        <v-expand-transition>
          <v-row v-show="show">
            <v-col
              cols="12"
              md="6"
              v-for="(giftcode, index) in giftcodes"
              :key="index"
              @click="goDetailPage(giftcode)"
            >
              <div class="giftcode-news-item">
                <div class="giftcode-news-item__image">
                  <img
                    :src="giftcode.game_icon"
                    alt=""
                    srcset=""
                    width="100%"
                  />
                </div>

                <div class="giftcode-news-item__text d-block">
                  <span class="giftcode-news-item__title d-block">
                    {{ giftcode.game_name }}
                  </span>
                  {{ giftcode.title }}
                  <span class="d-block">
                    <v-chip
                      class="giftcode-news-item__type white--text"
                      color="#e88d50"
                      >{{
                        giftcode.type === 'facebook'
                          ? $t('unique')
                          : $t('generic')
                      }}</v-chip
                    >
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-expand-transition>
      </div>
      <div v-else class="mt-4 text-center">Không có sự kiện diễn ra</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'GiftcodeNew',
  data: () => {
    return {
      show: true,
    }
  },
  created() {
    if (!this.$route.params.id) {
      this.$store.dispatch('GIFTCODE_REQUEST')
    }
  },
  computed: {
    ...mapGetters(['GIFTCODES', 'GIFTCODE_SHOW']),
    ...mapState(['status', 'giftcode_show']),
    giftcodes() {
      return this.$store.getters.GIFTCODES
    },
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) {
        this.show = false
      } else {
        this.show = true
      }
    },
    goDetailPage(item) {
      window.localStorage.setItem('game_id', item.game_id)
      this.$store.dispatch('GIFTCODE_SHOW', {
        event_id: item.id,
      })
      if (item.type === 'normal') {
        window.localStorage.setItem('received_code', true)
      }

      this.$store.commit('GIFTCODE_DETAIL', item)
      this.$router.push({
        name: 'GiftcodeDetail',
        params: {
          id: item.game_alias,
        },
        query: {
          evid: item.id,
        },
      })
    },
  },
}
</script>

<style lang="scss"></style>
